import PageLayout from "Layouts/PageLayout";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import PrintIcon from "Assets/SVG/PrintIcon";
import {useFoilType} from "../../../Apis/FoilTypeApi";
import FoilTypeForm from "Features/Prints/Components/FoilTypeForm";

const Edit = () => {
    
    const { t } = useTranslation();
    
    const { id } = useParams();
    
    const { data: foilType } = useFoilType(parseInt(id!));
    
    const navigate = useNavigate();
    
    return (
        <PageLayout title={t('updateFoilType')} icon={<PrintIcon />} includeBox>
            <FoilTypeForm foilType={foilType} onSubmit={_ => navigate(-1)} />
        </PageLayout>
    )
}

export default Edit;
